<template>
    <main>
        <div class="header"></div>
        <div class="bg">
            <div class="center">
                <div class="left crumbs-box">
                    <div class="tit">{{crumbs.title}}</div>
                    <div class="min-tit">{{crumbs.min_title}}</div>
                </div>
                <div class="right logo" style="display: none;">
                    <img :src="require('@/assets/image/2021/20.png')" alt="">
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'crumbs',
        data() {
            return {
                query:"",
            }
        },
        props:{
            crumbs:{
                type:Object,
                default:[]
            }
        },
        components:{

        },
        computed:{

        },
        methods: {

        },
        mounted() {
            this.query = this.$route.query;
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .header{position: fixed;top:0;left:0;width: 100%;min-width: 1200px; height:80px;text-align: center;color: #fff;border-bottom: 1px solid rgba(255,255,255,.2);z-index: 99;background: url("~@/assets/image/2026/nav-bg.png") no-repeat right top;}
    .bg{height:170px; background:url("~@/assets/image/2026/nav-bg.png") no-repeat right top;text-align: center;
        .center{display: inline-block;width: 1200px;overflow: hidden;
            .crumbs-box{color: #fff;text-align: left;margin-top: 86px;
                .tit{font-size: 36px;line-height: 36px;font-weight: bold;}
                .min-tit{font-size: 24px;line-height: 32px;font-weight: 100;opacity: .8;margin-top:5px;text-transform: uppercase;}
            }
            .logo{ float: right;margin-top: 152px;
                img{width: 230px;}
            }
        }
    }
</style>

